<web-batterie-icon *ngIf="panel.batteryState" [batterieState]="panel.batteryState"></web-batterie-icon>

<web-energy-info
    [label]="'GLOBAL.BATTERY' | translate"
    [value]="panel.battery"
    color="grey"
    [suffix]="
        panel.batteryState &&
        panel.batteryState !== batteryState.UNPLUGGED &&
        panel.batteryState !== batteryState.NOT_SUPPORTED
            ? '%'
            : ''
    "
    valueClass="sub-headline-bold short-line-height"
    suffixClass="sub-headline-bold short-line-height"
>
</web-energy-info>
